import { useContext } from "react";
import { GridStackContext } from "./context";

export function useGridStackContext() {
  const ctx = useContext(GridStackContext);
  if (!ctx) throw new Error("useGridStackContext must be used within GridStackProvider");
  return ctx;
}
